module.exports = __webpack_public_path__ + "static/img/slider-rev3.19e944f4.jpg";